'use client';

import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@eventbrite/marmalade';
import { CheckoutButton } from '../CheckoutButton/CheckoutButton';
import { RSVPModal } from './RSVPModal';
import { RSVPResponseType } from './types';
import { useLiveEventData } from '../hooks/useLiveEventData';
import { LISTING_HEAP_IDS } from '@/components/_shared/constants';
import styles from './RSVPPanel.module.scss';

export interface RSVPPanelProps {
  mipaToken: string | null;
}

interface RsvpModalState {
  open: boolean;
  responseType: RSVPResponseType | null;
}

export const RSVPPanel: React.FC<RSVPPanelProps> = ({ mipaToken }) => {
  const { eventId } = useLiveEventData();
  const [modalState, setModalState] = useState<RsvpModalState>({
    open: false,
    responseType: null,
  });

  const openModal = (responseType: RSVPResponseType) => setModalState({ open: true, responseType });
  const closeModal = () => setModalState({ open: false, responseType: null });

  return (
    <div className={styles.container} data-testid="rsvp-panel">
      <div className={styles.content}>
        <div className={styles.label} data-testid="rsvp-label">
          <FormattedMessage
            id="Are you going to this event?"
            defaultMessage="Are you going to this event?"
            description="RSVP label in conversion bar"
          />
        </div>
      </div>
      <div data-testid="cb-cta-area" className={styles.ctaButtonWrapper}>
        <CheckoutButton isRemindMe={false} isRSVP={true} />
        <Button
          variant="secondary"
          onClick={() => openModal('maybe')}
          data-heap-id={LISTING_HEAP_IDS.CTA_RSVP_MAYBE}
          data-testid="rsvp-maybe-button"
          className={styles.maybeButton}
        >
          <FormattedMessage id="Maybe" defaultMessage="Maybe" description="RSVP Maybe button" />
        </Button>
        <Button
          variant="ghost"
          onClick={() => openModal('no')}
          data-heap-id={LISTING_HEAP_IDS.CTA_RSVP_NO}
          data-testid="rsvp-no-button"
        >
          <FormattedMessage id="No" defaultMessage="No" description="RSVP No button" />
        </Button>
      </div>
      {modalState.responseType && (
        <RSVPModal
          visible={modalState.open}
          onClose={closeModal}
          responseType={modalState.responseType}
          eventId={eventId ?? ''}
          mipaToken={mipaToken}
        />
      )}
    </div>
  );
};
